import type { GeneralConfig } from '@shared/types/Config';

export const bundleConfig: GeneralConfig = {
    sortFieldMap: {},
};
